import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';


@Component({
  selector: 'create-edit-user',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="450" title="{{ (mode == 'CREATE') ? 'Nuevo' : 'Editar' }} {{ label }} {{ (mode == 'CREATE') ? '' : '(Id: ' + form.value.id + ')' }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">
          <div class="row">              
            <div class="col-xs-8 col-sm-8 offset-xs-2 offset-sm-2 example-col">
              <imagen-upload formControlName="image" [folder]="'users'"></imagen-upload>               
            </div>            
          </div>
          <div class="row">
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Usuario:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="user" [clearButton]="true" controlTrim></kendo-textbox>
                  </kendo-textbox-container>  
                  <div *ngIf="f.user.invalid && (f.user.dirty || f.user.touched)">                  
                    <div *ngIf="f.user.errors">
                      <kendo-formerror *ngIf="f.user.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Nombre:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="name" [clearButton]="true" controlTrim></kendo-textbox>
                  </kendo-textbox-container>
                  <div *ngIf="f.name.invalid && (f.name.dirty || f.name.touched)">                  
                    <div *ngIf="f.name.errors">
                      <kendo-formerror *ngIf="f.name.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>                
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Rol:"></kendo-label>                  
                  <dynamic-dropdownlist formControlName="id_role" [table]="'roles'" [valueField]="'id'" [textField]="'name'" [showAll]="true" (selected)="roleSelected($event)"></dynamic-dropdownlist>
              </div> 
          </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `],
  providers: [ DatasourceService ]
})
export class CreateEditUserComponent extends CreateEditWindowComponent {

  //Variables

  public selectedRoleId: number;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);

  }
  
  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,
      `Usuario: '${dataItem.user}'`,
      `Nombre: '${dataItem.name}'`,
      `Rol: '${dataItem.role}'`
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),
      'user': new FormControl((dataItem) ? dataItem.user: "", Validators.required),
      'name': new FormControl((dataItem) ? dataItem.name: "", Validators.required),
      'image': new FormControl((dataItem) ? dataItem.image: ""),
      'id_role': new FormControl((dataItem) ? dataItem.id_role: 3, Validators.required),
    });

  };

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, formGroup.value, { 
      password: (this.mode == 'CREATE') ? 'pass': formGroup.value.password,
      id_role: this.selectedRoleId
    });

  };

  protected roleSelected(sel) : void {

    console.log('VALUE:' + sel.value);
    console.log(sel.item);
    this.selectedRoleId = sel.value;

  }

}
